module.exports = __webpack_public_path__ + "img/2aaf7db.png";